import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiResponse } from '../../../shared/models/api-response.model';
import { HttpCommonService } from '../../../shared/services/http-common-service';
import { DashboardDto } from '../models/dashboard-dto';


@Injectable({
  providedIn: 'root'
})
export class DashboardService {
  baseUrl = 'Dashboard';
  constructor(private httpCommonService: HttpCommonService) {
  }

  getAgreementDashboard(): Observable<ApiResponse<DashboardDto>> {
    return this.httpCommonService.get<ApiResponse<DashboardDto>>({ url: this.baseUrl + "/Get" });
  }

 
}
